sceDelegateProvider.$inject = ['$sceDelegateProvider'];
export function sceDelegateProvider($sceDelegateProvider) {
  /**
   * Allows to flag the given domain as trusted.
   * The CDN download urls are used for the whatsapp templates.
   */
  return $sceDelegateProvider.resourceUrlWhitelist([
    "self",
    "https://cdn*.alcmeon.com/download/**",
    "https://alc-cdn*.global.ssl.fastly.net/**"
  ]);
}